import { isEqual } from 'lodash';
import store from '../../../../redux';
import { PracticeCombinations, PracticeTypes } from '../../../../service/estimate/interfaces';

export const getInitialBasedOnPracticeType = (practiceType: PracticeTypes, practiceName: string, pastureStatus?: 'degraded' | 'improved') => {
  const practiceTypeFormatted = practiceType === 'ROW_CROP' ? 'rowCrop' : `${pastureStatus}Pasture`;

  const allStore = store.getState();

  const practiceFromStore = allStore.estimate.availablePractices.find((practice) => practice.name === practiceName);

  return practiceFromStore?.brBufferConstants?.[practiceTypeFormatted]?.preBuffer ?? 0;
};

export const anyInvalidPracticeCombination = (scenarios, practiceCombinations: PracticeCombinations[]) => {
  return scenarios.some((sce) => {
    const scenarioPracticesShortCodes = sce.practices.map((prac) => prac.shortCode);

    if (!scenarioPracticesShortCodes.length) return false;

    return !practiceCombinations?.some((comb) => isEqual(comb.practices.sort(), scenarioPracticesShortCodes.sort()));
  });
};
